// extracted by mini-css-extract-plugin
export default {"link":"LayoutSwitcher_link__qfTMH"};